<template>
    <div>
        <Mixlr />
    </div>
</template>

<script setup>
import Mixlr from '../components/ListenOnline/Mixlr.vue'
</script>

<style lang="scss" scoped>

</style>